export function ifNotEmpty(obj, fn, defaultValue) {
  return !obj || !fn ? obj || defaultValue : fn(obj);
}
